import { zodKnownFieldDefaultValidation } from '@juvare/platform-shared/features/validation';
import { z } from 'zod';
export const AddressSchema = z.object({
    addressLine1: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // for example: 235 Peachtree St
    addressLine2: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // for example: Suite 2300
    city: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // for example: Atlanta
    state: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // 2 letter state postal code, for example: GA
    postalCode: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // also known as ZIP code, for example: 30303
    countyName: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // for example: Fulton County
    region: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(), // for example: Region 1
});
export function getAddressSingleLineString({ addressLine1, addressLine2, city, state, postalCode }) {
    const part1 = [addressLine1, addressLine2].filter((s) => !!s).join(' ');
    const part2 = city;
    const part3 = [state, postalCode].filter((s) => !!s).join(' ');
    return [part1, part2, part3].filter((s) => !!s).join(', ');
}
export function getAddressMultiLineString({ addressLine1, addressLine2, city, state, postalCode }) {
    const statePostalCode = [state, postalCode].filter((s) => !!s).join(' ');
    const cityStatePostalCode = [city, statePostalCode].filter((s) => !!s).join(', ');
    return [addressLine1, addressLine2, cityStatePostalCode].filter((s) => !!s).join('\n');
}
